export const nameToIDMatch = (url: string, obj: any) => {
    const id = url.split('/').pop();
    return id; //Object.keys(obj).find(key => obj[key] === id);
};
